export const SURVEY_QUESTION_TYPES = {
  TEXT: 'Text',
  NUMERIC_ZERO_THROUGH_FIVE: 'NumericZeroThroughFive',
  NUMERIC_ONE_THROUGH_FIVE: 'NumericOneThroughFive',
  NUMERIC_ONE_THROUGH_TEN: 'NumericOneThroughTen'
};